import React from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import FormHelperText from '@mui/material/FormHelperText';
import moment from 'moment';

export interface IDateInputProps {
    label : string;
    onDateChange : (date : Date | moment.Moment) => void;
    onBlur ?: () => void;
    className ?: string;
    disabled ?: boolean;
    error ?: string;
    value : Date | moment.Moment | null;
    format ?: string;
    type ?: 'date-fns' | 'moment';
}

const DateInput = (props : IDateInputProps) : React.ReactElement => {
    const {
        label,
        className,
        disabled,
        error,
        value,
        type,
        format = (type === 'date-fns' ? 'yyyy-MM-dd' : 'YYYY-MM-DD'),
    } = props;

    let parsedDate : Date | moment.Moment | null;
    if (type === 'date-fns' && !moment.isMoment(value)) {
        parsedDate = new Date(value ?? new Date());
    } else {
        parsedDate = value ;
    }

    const onChange = (date : Date | moment.Moment | null) : void => {
        if (date != null) {
            if (type === 'date-fns' && !moment.isMoment(value)) {
                props.onDateChange(date as Date);
            } else {
                props.onDateChange(moment(date));
            }
            if (props.onBlur) {
                props.onBlur();
            }
        }
    };

    return (
        <div className={`pl10 pr10 fdc ais jcfs ${className || ''}`}>
            <DatePicker
                disabled={disabled}
                value={parsedDate}
                onChange={onChange}
                format={format}
                label={label}
            />
            <FormHelperText error>{error || ''}</FormHelperText>
        </div>
    );
};

export default DateInput;
